<template>
<div>
    <div class="container MobileHide">
        <ul class="list-group">
             <div v-if="!cookiesObject.token">
                 <h3 class="MobileHide" style="text-align: center; font-weight: 600; color: #242224;">{{ $t('LanguageEn.txtRestrictToLogin') }}</h3>
                 <h3 class="MobileShow" style="text-align: center; font-weight: 600; color: #1b5e20; margin-top: 50px;">{{ $t('LanguageEn.txtRestrictToLogin') }}</h3>
             </div>
            <div v-for="fav in favsTe" :key="fav.key" v-else>
            <li class="list-group-item game" >
            <div class="row">
            <div class="col-1 bodyElement">
            <b-btn v-if="cookiesObject.token" v-on:click="removeFavorite({value: fav.id, type:match})" style="background: none; width: 5px; height: 20px; margin-top: -5px; border-radius: 25px; border: none;"> <img src="@/assets/delete.png" style="width: 10px; margin-top: -20px; margin-left: -7.5px;" alt=""> </b-btn> <b-btn v-else v-b-popover.hover.right="'Log in to add to favorites!'" style="float: right; margin-right: 10px; margin-top: 5px; background: none; width: 5px; height: 5px; border: none;"> <img src="@/assets/delete.png" style="width: 10px; margin-top: -30px; margin-left: -10px;" alt=""> </b-btn>           
            </div>
            <router-link class="col" id="router-link" :to="{ name: 'MatchPagePar', params: { gameId: fav.id } }">   
            <div class="row">
            <div class="col-1 bodyElement">
               {{fav.matchStatus.name}}
            </div>
            <div class="col bodyElement">
                {{fav.team1.name}}
            </div>
            <div class="col-1 bodyElement">
                {{fav.currentScore}}
            </div>
            <div class="col bodyElement">
                {{fav.team2.name}}
            </div>
                </div>
            </router-link>
        </div>
            </li>  
            </div>    
        </ul>
    </div>
    <div class="container MobileShow" style="background: #212529;">
    <div>
         <div v-if="!cookiesObject.token">
                 <h3 class="MobileShow" style="text-align: center; font-weight: 600; color: white; margin-top: 50px;">{{ $t('LanguageEn.txtRestrictToLogin') }}</h3>
             </div>
  <b-tabs content-class="mt-0" justified style="background: white;"  active-nav-item-class="text-white bg-success" v-else>
    <b-tab active>
    <template v-slot:title>
        <p style="margin: 0px; color: #333333; font-size: 12px;">{{ $t('LanguageEn.txtMatch') }}</p>
    </template>
    <ul class="list-group">
            <div v-for="fav in favsTe" :key="fav.key">
            <li class="list-group-item game" >
            <div class="row">
            <div class="col-1 bodyElement">
            <b-btn v-if="cookiesObject.token" v-on:click="removeFavorite({value: fav.id, type:match})" style="background: none; width: 5px; height: 20px; margin-top: -5px; border-radius: 25px; border: none;"> <img src="@/assets/delete.png" style="width: 10px; margin-top: -20px; margin-left: -7.5px;" alt=""> </b-btn> <b-btn v-else v-b-popover.hover.right="'Log in to add to favorites!'" style="float: right; margin-right: 10px; margin-top: 5px; background: none; width: 5px; height: 5px; border: none;"> <img src="@/assets/delete.png" style="width: 10px; margin-top: -30px; margin-left: -10px;" alt=""> </b-btn>           
            </div>
            <router-link class="col" id="router-link" :to="{ name: 'MatchPagePar', params: { gameId: fav.id } }">   
            <div class="row">
            <div class="col-1 bodyElement">
               {{fav.matchStatus.name}}
            </div>
            <div class="col bodyElement">
                {{fav.team1.name}}
            </div>
            <div class="col-1 bodyElement">
                {{fav.currentScore}}
            </div>
            <div class="col bodyElement">
                {{fav.team2.name}}
            </div>
                </div>
            </router-link>
        </div>
            </li>  
            </div>    
        </ul>
    </b-tab>
    <b-tab style="background: #212529;" >
    <template v-slot:title >
        <p style="margin: 0px; color: #333333; font-size: 12px;">{{ $t('LanguageEn.txtTeams') }}</p>
    </template>
        <HeaderBody  />
    </b-tab>
    <b-tab style="background: #212529;">
    <template v-slot:title>
        <p style="margin: 0px; color: #333333; font-size: 12px;">{{ $t('LanguageEn.txtLeagues') }}</p>
    </template>
       <Tournaments />
    </b-tab>
  </b-tabs>
</div>
    </div>
</div>
</template>

<script>
import {mapGetters, mapActions} from 'vuex';
import HeaderBody from '../LeftColumn/HeaderBody'
import Tournaments from '../LeftColumn/Tournaments'

export default {
  name: 'MyGames',
  data(){
      return{
          spinning: '',
          gameId: '',
          cookiesObject: '',
          match: 'match',

      }
  },
  async mounted(){
    var cookiesObject = document.cookie.split(';').map(cookie => cookie.split('=')).reduce((accumulator, [key, value]) => ({...accumulator, [key.trim()]: decodeURIComponent(value)}),{});
    this.cookiesObject = cookiesObject;

    },

    methods:{
      ...mapActions(["removeFavorite"]),       
    },  
  components: {
      HeaderBody,
      Tournaments,
  },
  props: {
    
  },
  computed: {
      ...mapGetters(["favsTe"]),
  },
}

</script>

<style scoped>
#router-link{
    color: black;
    text-decoration: none;
}

.container{
    margin-top: 12px;
}

li{
   line-height:5px;
   border-radius: 0px !important;
   font-size: 12px;
}
.LeagueName{
    margin-bottom: 10px;
}

.header{
    background: #242424;
    color: white;
}

.bodyElement{
    padding: 0;
    height: 8px;
}

.game{
    text-align: center;
}
.game :hover{
    color: #309a3d;
}


@media only screen and (max-width: 770px) {
  .bodyElement{
    padding: 0;
    height: 8px;
    }
    .MobileHide {
    display: none;
  }
}

@media only screen and (min-width: 770px) {
  .bodyElement{
    padding: 0;
    height: 8px;
    }
    .MobileShow {
    display: none;
  }
}
</style>
